export default __webpack_public_path__ + "static/media/tree1.2a789751.png";